import { SecurityKeyView } from "components/MFA/SecurityKeysList/types";
import { SecurityKey } from "types/generated";

export const mapSecurityKeysToView = (
  securityKeys: SecurityKey[] = [],
  isMFAEnforced: boolean
): SecurityKeyView[] => {
  return securityKeys.map((key) => ({
    ...key,
    canDelete: !isMFAEnforced || securityKeys.length > 1,
  }));
};
